import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21522 25401"
    {...props}
  >
    <path
      d="m5292 3267 5561 16470 5577-16585c292-875 509-1482 653-1819 148-343 388-646 720-921 338-275 795-412 1373-412 423 0 818 109 1184 321 361 211 647 491 853 846 206 349 309 704 309 1064 0 241-35 509-103 795-63 281-149 561-246 836-103 274-206 555-303 847l-5944 16052c-218 612-429 1196-641 1751-212 549-458 1035-738 1459-275 417-647 761-1110 1030-463 268-1030 400-1699 400-675 0-1241-132-1705-395-463-263-835-606-1121-1035-280-435-532-921-744-1471-211-543-423-1127-635-1739L687 4840c-104-286-207-572-309-852-109-281-195-584-269-904C34 2758 0 2483 0 2260c0-566 229-1087 687-1556C1144 235 1722 0 2414 0c847 0 1447 258 1797 778 354 521 715 1350 1081 2489z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
